<div class="modal fade" id="{{ Id }}" [attr.data-backdrop]="IsStatic ? 'static' : null" attr.style="z-index: {{ZIndex}};"
[ngStyle]="IsBackdrop ? { 'background-color': 'rgba(0, 0, 0, 0.5)' } : {}">
  <div class="modal-dialog {{CenteredClass}} {{ScrolledClass}} {{SizeClass}} {{IsShowLogo}}">
    <div class="modal-content">
      <div *ngIf="!HideHeader"class="modal-header pt-2 pb-2 modalHeaderBG">
        <div *ngIf="IsShowLogo" class="HumaHead">
          <img src="assets/images/humaHead.webp">
        </div>
        <h5 *ngIf="Title" class="modal-title {{TitleClass}}" id="exampleModalLabels{{ Id }}">{{ Title }}</h5>
        <ng-content select="[modal-header]"></ng-content>
        <button *ngIf="ShowCloseButton" type="button" class="close" data-toggle="modal" attr.data-target="#{{Id}}" (click)="CloseModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div [ngClass]="'modal-body'+ ModelBodyClass">
        <div [ngClass]="'container-fluid p-0'+ ContainerfluidClass">
          <ng-content select="[modal-body]"></ng-content>
        </div>
      </div>
      <div class="modal-footer pt-2 pb-2" *ngIf="ShowFooter">
          <button *ngIf="ShowCloseButton" type="button" [ngClass]="!SizeClass ? 'btn-sm' : ''" class="btn btn-secondary" id="btnModalClose" data-toggle="modal" attr.data-target="#{{Id}}" (click)="CloseModal()">Close</button>
          <ng-content select="[modal-footer]"></ng-content>
      </div>
    </div>
  </div>
</div>